module.exports = __webpack_public_path__ + "img/trunk_7x3_z18.57cb9f11.svg";